import { inject, Injectable } from '@angular/core';
import { AppConfigService } from '@app_services/appconfigservice';
import { JsonHelperService } from '@app_services/helper-json';
import { catchError, map, Observable, of } from 'rxjs';
import { BsportalstorageService } from './bsportalstorage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private bsportalstorageService = inject(BsportalstorageService);
  private jsonHelperService = inject(JsonHelperService);
  private appConfigService = inject(AppConfigService);

  private readonly baseUrl: string;
  constructor() {
    this.baseUrl = this.appConfigService.baseUrl;
  }
  isLoggedIn(): Observable<boolean> {
    return this.validateToken().pipe(
      map(isValid => {
        return isValid;
      }),
    );
  }

  private validateToken(): Observable<boolean> {
    const loginDetails = this.bsportalstorageService.getLoginDetails();
    if (!loginDetails?.sessionToken) {
      return of(false);
    }
    const body = { sessionToken: loginDetails.sessionToken };
    return this.jsonHelperService
      .postJson<any>(this.fullUrl('cxp/user/session/verify'), body)
      .pipe(
        map(response => {
          if (response.faultCode != '401' && response.success === true) {
            return true;
          } else {
            this.bsportalstorageService.clearSession();
            return false;
          }
        }),
        catchError(_ => {
          this.bsportalstorageService.clearSession();
          return of(false);
        }),
      );
  }

  fullUrl(path: string) {
    return `${this.baseUrl}${path}`;
  }

  hasCustomerRights(): boolean {
    const loginDetails = this.bsportalstorageService.getLoginDetails();
    return loginDetails?.loginType === 'CUSTOMER';
  }

  hasResellerRights(): boolean {
    const loginDetails = this.bsportalstorageService.getLoginDetails();
    return loginDetails?.loginType === 'RESELLER';
  }

  hasEnvironmentRights(): boolean {
    const loginDetails = this.bsportalstorageService.getLoginDetails();
    return loginDetails?.loginType === 'ENVIRONMENT';
  }

  hasAdminRights() {
    const vv = 0;
    if (!vv) {
      return false;
    }
    return false;
  }

  userName() {
    const loginDetails = this.bsportalstorageService.getLoginDetails();
    return `${loginDetails?.userInfo?.firstName} ${loginDetails?.userInfo?.lastName} `;
  }

  hasRole(roles: string[]): boolean {
    const loginDetails = this.bsportalstorageService.getLoginDetails();
    return roles.some(role => loginDetails?.userInfo?.userRole.includes(role));
  }
}
